var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"scroller",staticClass:"pdf-scroller",on:{"scroll":_vm.onScroll}},_vm._l((_vm.pages),function(p){return _c('div',{key:p.n,ref:"pageEls",refInFor:true,staticClass:"manual-page",style:({ height: p.height + 'px' }),attrs:{"data-page":p.n}})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }